/**
 * Türkçe para alanı (28.10.2026, #502 Sigorta / Kasko): kullanıcı "1.250.000,50" biçiminde yazar ve görür,
 * sunucuya kültürden bağımsız sayı (1250000.5) gider. CustomNumberInput'un `paraBicimi` seçeneği kullanır;
 * diğer sayı alanları (sayiGirdisi) değişmez.
 *
 * Okuma kuralı (sayiGirdisi'nden farkı: "12.500" on iki bin beş yüzdür):
 *   - Hem nokta hem virgül varsa en sondaki ondalık, diğeri binliktir: "1.250.000,50", "1,250,000.50".
 *   - Yalnız virgül: son virgül ondalık ("12,5"; "1,250,000" gibi 3'lü gruplar binlik).
 *   - Yalnız nokta: her noktadan sonra tam 3 rakam varsa binlik ("12.500", "1.234.567"), değilse son nokta ondalık ("12.50").
 */
export const paraMetniniOku = (_metin: string | undefined | null): number | undefined => {
    const s = (_metin ?? '').replace(/\s/g, '').replace(/[^0-9.,-]/g, '');

    if (s === '' || s === '-')
        return undefined;

    const eksi = s.startsWith('-');
    const govde = s.replace(/-/g, '');
    const nokta = govde.includes('.');
    const virgul = govde.includes(',');

    const ucluGruplar = (ayirac: string) => govde.split(ayirac).slice(1).every(g => /^\d{3}$/.test(g)) && /^\d+$/.test(govde.split(ayirac)[0]);

    let duz: string;
    if (nokta && virgul) {
        const son = Math.max(govde.lastIndexOf('.'), govde.lastIndexOf(','));
        duz = govde.slice(0, son).replace(/[.,]/g, '') + '.' + govde.slice(son + 1);
    } else if (nokta || virgul) {
        const ayirac = nokta ? '.' : ',';
        const adet = govde.split(ayirac).length - 1;
        // Tek virgül her zaman ondalıktır ("12,500" = 12,5); noktada ve çoklu virgülde 3'lü gruplar binliktir.
        if ((nokta || adet > 1) && ucluGruplar(ayirac))
            duz = govde.split(ayirac).join('');
        else {
            const son = govde.lastIndexOf(ayirac);
            duz = govde.slice(0, son).split(ayirac).join('') + '.' + govde.slice(son + 1);
        }
    } else
        duz = govde;

    const sayi = Number(duz);

    if (isNaN(sayi))
        return undefined;

    return eksi ? -sayi : sayi;
}

/** 1250000.5 -> "1.250.000,50"; boşsa "". */
export const paraYaz = (_sayi: number | undefined | null): string =>
    _sayi == null || isNaN(_sayi) ? '' : _sayi.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Alan bırakıldığında (blur) metni Türkçe biçime getirir; okunamıyorsa olduğu gibi bırakır. */
export const paraMetniniBicimle = (_metin: string | undefined): string => {
    const sayi = paraMetniniOku(_metin);
    return sayi === undefined ? (_metin ?? '') : paraYaz(sayi);
}

/** Yazarken yalnız rakam, nokta, virgül (ve izinliyse baştaki eksi) kalır; biçimleme blur'da. */
export const paraYaziminiSuz = (_metin: string, _negatifSerbest: boolean = false): string =>
    _negatifSerbest ? _metin.replace(/(?!^)-|[^0-9.,-]/g, '') : _metin.replace(/[^0-9.,]/g, '');
